通用输入框

<template>
  <el-form-item :label="title" :id="field.FIELD_ID" :ref="field.FIELD_ID" :class="itemClass" v-if="isShow"
    :prop="field.FIELD_ID" :rules="rules">
    <div v-if="hasPwd" class="input" :class="'ignore-password-input'">
      <el-input :class="field.FIELD_ID + '_pass enctry'" value="******" disabled ></el-input>
      <el-button class="use-check-button" v-if="isShowButton" @click="clickButton">{{ fieldButtonTxt || "重设密码" }}</el-button>
    </div>
    <div class="input" v-else :class="getType == 'password' ? 'ignore-password-input' : ''">
      <el-input v-model="value" :disabled="isDisabled" :placeholder="field.PLACE_HOLDER" :type="getType" :autosize="{ minRows: 2, maxRows: 30}"
        :maxlength="maxlength" @blur="onBlur($event)" @focus="onFocus($event)"
        :id="getType == 'password' ? field.FIELD_ID + '_pass' : field.FIELD_ID"
        :class="getType == 'password' ? field.FIELD_ID + '_pass' : field.FIELD_ID"></el-input>
      <div class="input-unit" v-if="field.unitText">{{ field.unitText }}</div>
      <el-button class="use-check-button" v-if="isShowButton"
        :disabled="buttonEnable != undefined ? buttonEnable : isDisabled" @click="clickButton">
        {{ fieldButtonTxt || "校验" }}</el-button>
      <el-checkbox v-model="field.isCheckCheckbox" class="use-check-checkbox" v-if="isShowCheckbox"
        :disabled="checkboxDisable" @change="onChangeCheckBox($event, field.isCheckCheckbox)">
        {{ fieldCheckboxTxt || "无" }}</el-checkbox>
    </div>
    <div v-if="field.MESSAGE_REMINDER" class="message-reminder el-icon-warning" v-html="field.MESSAGE_REMINDER"></div>
  </el-form-item>
</template>

<script>
import validateRules from "./validateRules";

export default {
  data () {
    return {
      itemClass: "self-normalInput",
      isDisabled: false,
      rules: [],
      buttonEnable: false,
      timeInterval: "",
      maxlength: 2500,
    };
  },
  props: ["field", "index", "isBaseUI"],
  created () {
    this.rules.push({
      validator: this.validatorField,
      trigger: this.triggerType
    });
  },
  mounted () {
    this.itemClass += " " + this.field.FIELD_ID;
    if (this.field.FIELD_CLASS) {
      this.itemClass += " " + this.field.FIELD_CLASS;
    }
    // 
    if (this.field.VALID_TYPE.includes("max[")) {
      /max\[(\d+)\]/.exec(this.field.VALID_TYPE);
      this.maxlength = parseInt(RegExp.$1);
    }
    if (this.isRequired) this.itemClass += " self-normalInput-required";

    if (this.isShowChange) this.itemClass += " self-normalInput-changed";

    if (this.isShowButton) this.itemClass += " self-normalInput-showButton";

    if (this.isShowCheckbox) this.itemClass += " self-normalInput-showCheckbox";
  },
  beforeDestroy () {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
      this.buttonEnable = false;
      this.field.FIELD_BUTTON_TXT = this.field.OLD_FIELD_BUTTON_TXT || "发送验证码";
      this.field.codeStatus = "";
    }
  },
  destroyed () { },
  computed: {
    value: {
      get: function () {
        if(typeof this.field.DEFAULT_VALUE == "string"){
          return this.field.DEFAULT_VALUE.trim();
        }
        return this.field.DEFAULT_VALUE;
      },
      set: function (val) { 
        if(typeof val == "string"){
          this.field.DEFAULT_VALUE = val&&val.trim();
        }
        this.field.DEFAULT_VALUE = val;
      }
    },
    fieldButtonTxt: {
      get: function () {
        return this.field.FIELD_BUTTON_TXT;
      },
      set: function () { }
    },
    fieldCheckboxTxt: {
      get: function () {
        return this.field.FIELD_CHECKBOX_TXT;
      },
      set: function () { }
    },
    checkboxDisable: function () {
      return this.field.CHECKBOX_DISABLE;
    },
    isCheckCheckbox: function () {
      return this.field.isCheckCheckbox;
    },
    messageChange: function () {
      return this.field.message;
    },
    dataChange: function () {
      return this.field.DEFAULT_VALUE;
    },
    title: function () {
      this.field.FIELD_TITLE =
        (this.field.FIELD_TITLE &&
          this.field.FIELD_TITLE.replace("\\n", "\n")) ||
        "";
      return _.trim(this.field.FIELD_TITLE)
        ? this.field.FIELD_TITLE +
        (_.intersection(this.field.FIELD_TITLE.split(""), ["：", ":"])
          .length
          ? ""
          : "：")
        : "";
    },
    isShowButton: function () {
      return this.field.IS_SHOW_BUTTON;
    },
    isShowCheckbox: function () {
      return this.field.IS_SHOW_CHECKBOX;
    },
    hasPwd: function (){
      let flag = this.field.hasRsaPwd;
      return flag;
    },
    isRequired: function () {
      return parseInt(this.field.FIELD_REQUIRED) ? true : false;
    },
    isShow: function () {
      let fieldControl = parseInt(this.field.FIELD_CONTROL);
      if (fieldControl == 2) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }

      if (fieldControl === 0 || fieldControl === 2) {
        return true;
      } else {
        return false;
      }
    },
    getType: function () {
      let type = "text";
      let vTypes = this.field.VALID_TYPE.split("|");
      if (vTypes.includes("password")) {
        return "password";
      }
      for (let i = 0; i < vTypes.length; i++) {
        switch (vTypes[i].split("[")[0]) {
          case "password":
            type = "password";
            break;
          case "mobile":
          case "postcode":
          case "num":
          case "numberex":
            type = "number";
            break;
          case "textarea":
            type = "textarea";
            break;
          default:
            // type = "text";
            break;
        }
      }

      return type;
    },
    isShowChange: function () {
      return this.field.showchange;
    },
    triggerType: function () {
      return (
        (this.field.VALID_TYPE.indexOf("on-focus") > -1 && "focus") ||
        ["change", "blur"]
      );
    }
  },
  methods: {
    clickButton () {
      if(this.getType == "password"){
        //隐藏重设密码按钮 清空密码
        this.field.hasRsaPwd = false;
        this.field.IS_SHOW_BUTTON = false;
        this.field.DEFAULT_VALUE = "";
      }
      if (this.isBaseUI) {
        this.$emit("click-button");
      } else {
        let data = {};
        data["MODULE_ID"] = this.field.MODULE_ID;
        data["index"] = this.index;
        data["FIELD_ID"] = this.field.FIELD_ID;
        data["GROUP_ID"] = this.$parent.$parent.$parent.moduleItem.GROUP_ID;
        this.$store.commit(this.$types.UPDATE_COMPONENT_BUTTON_CLICK, data);
      }
    },
    validatorField: function (rule, value, callback) {
      //有历史rsa密码且未重设密码 跳过密码校验
      if(this.getType == "password" &&  this.field.hasRsaPwd){
        return true;
      }
       
      value = this.field.DEFAULT_VALUE;
      if (_.trim(value) === "" && this.isRequired && this.isShow) {
        if (this.field.FIELD_NEED_CHECK_EMPTY) { // 字段需要校验空值 触发FIELD_FUNCTION
          this.$store.commit(this.$types.UPDATE_FIELD_CHANGE, {
            field_id: this.field.FIELD_ID,
            module_id: this.field.MODULE_ID,
            index: this.index
          });
        }
        this.showErrorMsg = this.field.CUSTOM_ERR_MESSAGE || this.field.FIELD_TITLE + "为必填项"; // 如字段有CUSTOM_MESSAGE则展示
        this.field.message = this.showErrorMsg;
        this.field.correct = false;
        this.field.showerr = true;
        this.field.FIELD_CONTROL = "0";
        return callback(new Error(this.showErrorMsg));
      } else {
        let isError = false;
        let vParts = this.field.VALID_TYPE.split("|")[0].split("[");
        let vType = vParts[0];
        let vParam = vParts.length > 1 ? JSON.parse("[" + vParts[1]) : null;
        let rule = vType in validateRules ? validateRules[vType] : false;
        //手机号码超过11位禁止输入
        if (rule.limitLength) {
          value = value.substring(0, rule.limitLength);
          this.field.DEFAULT_VALUE = value;
          this.$children[0].$children[0].currentValue = value;
        }
        if (rule && _.trim(value) !== "") {
          isError = !rule.valid(value, vParam);
          if (isError) {
            let message = rule.msg;
            if (vParam != null) {
              for (let i = 0; i < vParam.length; i++) {
                message = message.replace(
                  new RegExp("\\{" + i + "\\}", "g"),
                  vParam[i]
                );
              }
            }
            this.showErrorMsg = message;
            this.field.message = message;
            this.field.correct = false;
            this.field.showerr = true;
            return callback(new Error(this.showErrorMsg));
          } else if (this.field.message) {
            // 关联逻辑判断中传过来要显示的message
            this.showErrorMsg = this.field.message;
            this.field.correct = false;
            this.field.showerr = true;
            return callback(new Error(this.showErrorMsg));
          } else {
            return this.lastValidate(rule, value, callback);
          }
        } else {
          return this.lastValidate(rule, value, callback);
        }
      }
    },
    lastValidate (rule, value, callback) {
      //新增优化 过滤掉非必填和不可编辑的

      //如果设置了二次输入确认，需要再次输入
      let that = this;
      if (
        this.field.VALID_TYPE.indexOf("prompt") > -1 &&
        this.field.promptValue != this.field.DEFAULT_VALUE &&
        this.field.DEFAULT_VALUE.length === 6 &&
        !!this.field.DEFAULT_VALUE &&
        that.field.message === ""
      ) {
        let that = this;
        consoleLog("弹窗开始");
        that.password({
          title: "请再次输入" + that.field.FIELD_TITLE,
          info: "",
          isSecondCheck: true,
          pwd: this.field.DEFAULT_VALUE,
          confirmedAction: () => {
            that.field.message = "";
            that.field.promptValue = that.field.DEFAULT_VALUE;
          },
          canceledAction: () => {
            that.field.promptValue = "";
            that.field.message = "需要再次输入" + that.field.FIELD_TITLE;
          }
        });
      }
      //如果该字段需要二次输入，且二次输入值不等于字段的值，则校验失败
      if (
        !this.isBaseUI &&
        !this.$parent.$parent.$parent.$parent.$parent.$parent.$parent
          .isRunFieldRules
      ) {
        if (
          this.field.VALID_TYPE.indexOf("prompt") > -1 &&
          this.field.promptValue != this.field.DEFAULT_VALUE &&
          this.field.DEFAULT_VALUE.length === 6 &&
          this.field.FIELD_REQUIRED == "1" &&
          this.field.FIELD_CONTROL == "0"
        ) {
          this.showErrorMsg = this.field.message = "两次输入不一致，请再次输入";
          this.field.correct = false;
          this.field.showerr = true;
          return callback(new Error(this.showErrorMsg));
        }
      }

      this.field.correct = true;
      this.showErrorMsg = "";
      this.field.message = "";
      this.field.showerr = false;
      if (this.isBaseUI) {
        let that = this;
        //这里支持组件拿取关联异步函数的返回值
        return that.$parent.fieldChangeWrap(that.field).then(function (err) {
          err && (that.field.correct = false) && (that.field.showerr = true);
          return err ? callback(new Error(err)) : callback();
        });
      } else {
        this.$store.commit(this.$types.UPDATE_FIELD_CHANGE, {
          field_id: this.field.FIELD_ID,
          module_id: this.field.MODULE_ID,
          index: this.index
        });
      }
      return callback();
    },
    onFocus: function () {
      // 获取焦点，判断是否应用失焦触发校验
      if (this.field.VALID_TYPE.indexOf("on-blur") > -1) {
        this.$refs[this.field.FIELD_ID]["rules"][0]["trigger"] = "blur";
      }
      if (this.field.VALID_TYPE.indexOf("on-focus") > -1) {
        this.$refs[this.field.FIELD_ID]["rules"][0]["trigger"] = "focus";
        //看了elenet-ui form源码 发现不支持foucus 所以手动校验一下 @liwei 2019/1/7
        this.$refs[this.field.FIELD_ID].$el.querySelector("input").blur();

        setTimeout(
          function () {
            this.validatorField({}, "", new Function());
          }.bind(this),
          300
        );
      }
    },
    onBlur: function (e) {
      // consoleLog("触发失去焦点事件", this.field.FIELD_ID);
      // consoleLog(
      //   "e.relatedTarget",
      //   e && e.relatedTarget && e.relatedTarget.className
      // );
      //防止关闭弹框也触发了输入框的校验事件，relatedTarget要么为null要么只能为输入框
      // 　if(!e.relatedTarget || (e&&e.relatedTarget&&e.relatedTarget.className == 'el-input__inner')){
      //只要不是弹窗的都响应，修复输入框输入，然后直接点击按钮不执行blur事件 linsc
      if (!(e.relatedTarget && e.relatedTarget.className == "el-message-box__headerbtn")) {
        if (this.field.VALID_TYPE.indexOf("on-focus") > -1) {
          this.$refs[this.field.FIELD_ID]["rules"][0]["trigger"] = "focus";
        } else {
          this.$refs[this.field.FIELD_ID]["rules"][0]["trigger"] =
            ["change", "blur"];
        }
        // 先执行校验程序 不然this.field.message 没有值
        this.validatorField({}, "", new Function());
        //如果错误信息包含再次输入，则是点击了取消按钮
        if (this.field.message.includes("再次输入") || this.field.message.includes("重新输入")) {
          this.field.message = "";
        }

      }
    },
    onChangeCheckBox: function (isChoose, value) {
      if (isChoose) {
        this.field.isCheckCheckbox = true;
      } else {
        this.field.isCheckCheckbox = false;
      }
      if (this.isBaseUI) {
        this.$parent.fieldCheckClickWrap(this.field);
      } else {
        let data = {
          "GROUP_ID": this.$parent.$parent.$parent.moduleItem.GROUP_ID,
          "MODULE_ID": this.field.MODULE_ID,
          "FIELD_ID": this.field.FIELD_ID,
          "index": this.index,
        };
        this.$store.commit(this.$types.UPDATE_COMPONENT_BUTTON_CLICK, data);
      }
    }
  },
  watch: {
    fieldButtonTxt: function (val) {
      this.fieldButtonTxt = val;
    },
    fieldCheckboxTxt: function (val) {
      this.fieldCheckboxTxt = val;
    },
    // checkboxDisable: function (val) {
    //   this.checkboxDisable = _.isUndefined(val) ? false : val;
    // },
    isCheckCheckbox: function (val) {
      this.clickButton();
    },
    "field.BUTTON_ENABLE": {
      handler (newVal, oldVal) {
        this.buttonEnable = newVal;
      },
      immediate: true
    },
    "field.VALID_TYPE": {
      handler (newVal, oldVal) {
        if (newVal.includes("max[")) {
          /max\[(\d+)\]/.exec(newVal);
          this.maxlength = parseInt(RegExp.$1);
        }
      },
      immediate: true
    },
    isRequired: function (val) {
      if (val) {
        this.itemClass += " self-normalInput-required";
      } else {
        this.itemClass = this.itemClass.replace(
          /self-normalInput-required/g,
          ""
        );
      }
      //ljc:保证在将字段从必填到非必填时触发
      this.$refs[this.field.FIELD_ID] && this.$refs[this.field.FIELD_ID].validate("change");
    },
    isShowChange: function (val) {
      if (val) {
        this.itemClass += " self-normalInput-changed";
      } else {
        this.itemClass = this.itemClass.replace(
          /self-normalInput-changed/g,
          ""
        );
      }
    },
    isShowCheckbox: function (val) {
      if (val) {
        this.itemClass += " self-normalInput-showCheckbox";
      } else {
        this.itemClass = this.itemClass.replace(
          /self-normalInput-showCheckbox/g,
          ""
        );
      }
    },
    isShowButton: function (val) {
      if (val) {
        this.itemClass += " self-normalInput-showButton";
      } else {
        this.itemClass = this.itemClass.replace(
          /self-normalInput-showButton/g,
          ""
        );
      }
    },
    messageChange: function (val) {
      // if(val){
      this.$refs[this.field.FIELD_ID].validate("change"); // 自定义触发校验事件
      // }
    },
    dataChange: {
      handler (newVal, oldVal) {
        //ocr识别回填字段时，会监听到，但是不需要去除ocr标识
        if(oldVal){
          //如果输入框中的值发生变化，ocr标识消失
          this.field.DATA_SOURCE = 0;
        }
        this.field.message = "";
      // if (val.length > this.maxlength) {
      // 注释slice方法 1，maxlength在Chrome上没有生效；2，此处修改DEFAULT_VALUE后校验逻辑也不正常@zhaoyr
      // this.field.DEFAULT_VALUE = this.field.DEFAULT_VALUE.slice(0, this.maxlength)
      // }
      },
      immediate: true
    },
    // dataChange: function (val) {
    //   this.field.message = "";
    //   //如果输入框中的值发生变化，ocr标识消失
    //   this.field.DATA_SOURCE = 0;
    //   // if (val.length > this.maxlength) {
    //   // 注释slice方法 1，maxlength在Chrome上没有生效；2，此处修改DEFAULT_VALUE后校验逻辑也不正常@zhaoyr
    //   // this.field.DEFAULT_VALUE = this.field.DEFAULT_VALUE.slice(0, this.maxlength)
    //   // }
    // },
    //监控验证码参数 如果改变且值为codeStart 则开启倒计时
    "field.codeStatus": function (val) {
      if (val == "codeStart") {
        this.timeInterval && clearInterval(this.timeInterval);
        let remainTime = this.field.remainTime || 120;
        this.timeInterval = setInterval(() => {
          remainTime--;
          if (remainTime >= 0) {
            this.buttonEnable = true;
            this.field.FIELD_BUTTON_TXT = `${remainTime}秒`;
            return;
          }
          this.buttonEnable = false;
          this.field.FIELD_BUTTON_TXT = this.field.OLD_FIELD_BUTTON_TXT || "发送验证码";
          this.field.codeStatus = "";
          clearInterval(this.timeInterval);
        }, 1000);
      }
      if (val == "codeEnd") {
        this.timeInterval && clearInterval(this.timeInterval);
        this.buttonEnable = false;
        this.field.FIELD_BUTTON_TXT = this.field.OLD_FIELD_BUTTON_TXT || "发送验证码";
        this.field.codeStatus = "";
      }
    },
    "field.DATA_SOURCE": {
      handler (val, oldVal) {
        this.itemClass = this.itemClass.replace("ocrIcon","");
        this.itemClass = this.itemClass.replace("zzIcon","");
        this.itemClass = this.itemClass.replace("zdIcon","");
        if (val == "1") {
          this.itemClass += " ocrIcon";
        } else if (val == "2") {
          this.itemClass += " zzIcon";
        } else if (val == "3") {
          this.itemClass += " zdIcon";
        }
      },
      immediate: true
    }
  },
};
</script>

<style lang="less">
@import "~@/styles/less/variable.less";
.self-normalInput {
  width: 100%;
  display: flex;
  font-size: large;//添加
  color: orange !important;//添加
  .el-form-item__content {
    flex: 1;
    .input {
      position: relative;
      display: inline-flex;
      width: 100%;
      .el-input {
        display: inline-flex;
        flex: 1;
      }
      .el-button {
        border-left: none;
        // flex: 0 0 60px;
        display: inline-flex;
        width: auto;
        min-width: 80px;
        justify-content: center;
        align-items: center;
        background: #f59a23;
        color: #fff;
        font-size: 12px;
        &.use-check-button {
          &.is-disabled {
            background: #dcdfe6;
          }
        }
      }
      .input-unit {
        position: absolute;
        right: 22px;
        top: 14px;
        color: #515a6e
      }

       /* 设置 el-textarea 的文本颜色 */
      .el-textarea .el-textarea__inner {
        font-size: 14px;
        height: 50px;
        white-space: pre-wrap;//自动换行
        overflow-wrap: break-word;//允许设置单词内换行
        position: relative;
      }
      .el-textarea .el-textarea__inner:focus {
        border-color: rgba(70, 102, 234, 1);
      }

    }
    .message-reminder {
      &::before {
        margin-right: 8px;
      }
      color: #f3800e;
      position: relative;
      left: -10px;
    }
  }
}

.self-normalInput-required {
  .el-form-item__label:before {
    content: "*";//必填项目，前面的小*
    // color: #f56c6c;//原始
    color: #ed4014;//修改后,前面的小*设置，见证的;
    margin-right: 4px;
    // color: blue !important;
  }
}

.self-normalInput-changed {
  input.el-input__inner {
    // background: rgba(252, 230, 56, 0.2) !important;
  }
}

.self-normalInput-showButton {
  .el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .el-button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left-width: 0;
  }
}

.self-normalInput-showCheckbox {
  .el-checkbox {
    border: none;
    flex: 0 0 60px;
    display: inline-flex;
    width: 150px;
    height: 40px;
    align-items: center;
    padding: 0px 30px 0px 10px;
    .el-checkbox__input {
      .el-checkbox__inner {
        width: 20px;
        height: 20px;
        // background: rgba(234, 237, 240, 1);
        // border: 2px solid rgba(205, 207, 216, 1);
        background: rgb(250, 250, 250);
        border: 1px solid rgb(199, 199, 199);
        border-radius: 4px;
        box-sizing: border-box;
      }
    }
    .el-checkbox__input.is-checked {
      .el-checkbox__inner {
        background: #409eff;
        border-color: #409eff;
      }
      .el-checkbox__inner::after {
        height: 10px;
        width: 4px;
        left:6px;
        border-width: 2px;
      }
    }
    .el-checkbox__label {
      // font-size: 22px;//原始
      font-size: 14px;
      padding-left: 5px;
    }
  }
}

// .el-message-box.prompt-msgbox{
//   height: 270px;
//   text-align: center;
//   .el-message-box__title{
//     font-size: 24px;
//   }
//   .el-message-box__headerbtn{
//     font-size: 24px;
//   }
//   .el-message-box__content{
//     padding: 20px 30px 10px;
//     font-size: 22px;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/preEntry/normalInputItem.vue